import * as ActionTypes from './actionTypes';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';
import {getUrlParameters} from '../../common/util/urlParameters';

export const fetchAmountReportDetail = (filters) => {
  const allFilters = getUrlParameters(filters);

  return apiActionCreator({
    'endpoint': `/orders/providers/amount-control/report${allFilters}`,
    'authenticated': true,
    'types': [
      ActionTypes.FETCHING_AMOUNT_REPORT_DETAIL_LIST,
      ActionTypes.FETCHED_AMOUNT_REPORT_DETAIL_LIST,
      [ActionTypes.FETCHED_AMOUNT_REPORT_DETAIL_LIST_FAILED, (error) => buildErrorMessage(error)],
    ],
    'microservice': 'part',
    'method': 'GET',
  });
};

export const fetchDownloadAmountReportDetail = (filters = {}) =>
  apiActionCreator({
    'endpoint': '/orders/providers/amount-control/report',
    'authenticated': true,
    'types': [
      ActionTypes.DOWNLOAD_AMOUNT_REPORT_DETAIL,
      ActionTypes.DOWNLOAD_AMOUNT_REPORT_DETAIL_SUCCESS,
      [ActionTypes.DOWNLOAD_AMOUNT_REPORT_DETAIL_ERROR, (error) => buildErrorMessage(error)],
    ],
    'microservice': 'part',
    'method': 'POST',
    'contentType': 'application/json',
    'data': filters,
  });

export const clearAmountReportDetail = () => ({
  'type': ActionTypes.CLEAR_AMOUNT_REPORT_DETAIL,
});

export const changeAmountReportDetailListPage = (value) => ({
  'type': ActionTypes.CHANGE_AMOUNT_REPORT_DETAIL_LIST_PAGE,
  'payload': value,
});

export const changeAmountReportDetailListPageSize = (value) => ({
  'type': ActionTypes.CHANGE_AMOUNT_REPORT_DETAIL_LIST_PAGE_SIZE,
  'payload': value,
});
